var map = {
	"./1.svg": 63923,
	"./10.svg": 66603,
	"./11.svg": 87933,
	"./12.svg": 27990,
	"./13.svg": 21851,
	"./14.svg": 80389,
	"./15.svg": 71988,
	"./16.svg": 10091,
	"./17.svg": 85646,
	"./18.svg": 54718,
	"./19.svg": 34464,
	"./2.svg": 13407,
	"./20.svg": 58310,
	"./21.svg": 50218,
	"./22.svg": 68950,
	"./23.svg": 42977,
	"./24.svg": 8596,
	"./25.svg": 52956,
	"./26.svg": 90364,
	"./27.svg": 37739,
	"./28.svg": 68830,
	"./29.svg": 42528,
	"./3.svg": 35153,
	"./30.svg": 55052,
	"./4.svg": 26866,
	"./5.svg": 14802,
	"./6.svg": 43546,
	"./7.svg": 47037,
	"./8.svg": 44055,
	"./9.svg": 77567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84497;